import { Component, OnInit } from '@angular/core';
import { Contact } from '@vendasta/sales-v2';
import { AuxDataAccountsTableColumnDirective } from '../auxiliary-data-accounts-table-column.directive';

@Component({
  template: `
    <ng-container *ngIf="displayedPrimaryContact; else emptyState">
      <div class="flex-container">
        <div>
          <va-icon
            [diameter]="32"
            [iconName]="(assignedContact?.firstName || '') + ' ' + (assignedContact?.lastName || '')"
          ></va-icon>
        </div>
        <div class="info">
          <div>{{ assignedContact.firstName }} {{ assignedContact.lastName }}</div>
          <div>
            {{ assignedContact.phoneNumber || assignedContact.contactEmail || '-' }}
          </div>
        </div>
      </div>
    </ng-container>
    <ng-template #emptyState>-</ng-template>
  `,
  styles: ['.flex-container { display: flex; }', '.info { margin-left: 8px; }'],
  standalone: false,
})
export class PrimaryContactColumnComponent extends AuxDataAccountsTableColumnDirective implements OnInit {
  displayedPrimaryContact: boolean;
  assignedContact: Contact;

  constructor() {
    super();
  }

  private hasContactInfo(): boolean {
    if (this.assignedContact?.firstName || this.assignedContact?.lastName) {
      return true;
    }
    return false;
  }

  ngOnInit(): void {
    this.assignedContact = this.element?.primaryContact;
    this.displayedPrimaryContact = this.hasContactInfo();
  }
}
